var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { AccordionSummary, Box } from "@mui/material";
import { faAngleDown } from "@fortawesome/pro-regular-svg-icons/faAngleDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export const TruffleAccordionSummary = (props) => {
    const { icon, text, padding, sx, summarySxProps } = props, accProps = __rest(props, ["icon", "text", "padding", "sx", "summarySxProps"]);
    const sxProps = Object.assign(Object.assign({}, sx), { minHeight: padding ? "48px" : "32px", padding: padding ? "8px" : "0", display: "flex", alignItems: "center", alignSelf: "stretch", "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: "0"
        }, "&.Mui-expanded": {
            minHeight: 0,
            margin: "12px 0"
        } });
    return _jsx(AccordionSummary, Object.assign({ sx: sxProps, 
        // By default, MUI Accordion Summary rotates the expand icon by 180 degrees when expanding (meaning the collapse icon will be a rotated version of angleDown),
        //          and we're fine with this for now
        expandIcon: _jsx(FontAwesomeIcon, { icon: faAngleDown }) }, accProps, { children: _jsxs(Box, { sx: Object.assign({ display: "flex", alignItems: "center", alignSelf: "stretch", gap: "8px", "& .MuiTypography-root": {
                    // Figma requires a 48 px height for the summary block.
                    //  Normally this is achieved in MUI because the line height of the Typography is 24px + 12px margin at the top and bottom ==> 48px.
                    //  But since we'll usually be using "body1" typography, which reduces the line height to 21px, we override the line height here.
                    lineHeight: "24px"
                } }, summarySxProps), children: [icon, text] }) }));
};
//# sourceMappingURL=TruffleAccordionSummary.js.map